import { Switch } from '@mui/material'
import React from 'react'

function SwitchCustom({
    value,
    checked,
    onChange
}) {
    return (
        <Switch 
            sx={{
                '& .MuiSwitch-switchBase.Mui-checked': {
                    color: '#FC581F', // Thumb color when checked
                    '& + .MuiSwitch-track': {
                        backgroundColor: '#FC581F', // Track color when checked
                    },
                },
            }}
            value={value}
            checked={checked}
            onChange={onChange}
        />
    )
}

export default SwitchCustom